import { render, staticRenderFns } from "./gantt-wrapper.vue?vue&type=template&id=32732ee8&"
import script from "./gantt-wrapper.vue?vue&type=script&lang=js&"
export * from "./gantt-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports